/**
 * @enum {String}
 */
export const VolumeName = {
  Sample: 'Sample',
  Buffer: 'Buffer',
  FinalVolume: 'Final Volume',
  Tube1: 'Left Tube',
  Tube2: 'Right Tube',
  EstCurrentBuffer: 'Est. Current Buffer',
};

/**
 * @enum {Number}
 */
export const ChartZoomLevel = {
  MINIMUM_ZOOM_LEVEL: 1,
  MAXIMUM_ZOOM_LEVEL: 10,
};

export const ID_CHART = '#chart';
